var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapsulasIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m58 53h-3v-1a3.0033 3.0033 0 0 0 -3-3h-8.0333a4.971 4.971 0 0 0 .8731-4.1514l-1.8564-7.8486h1.2617a.9953.9953 0 0 1 .9737.77l.5771 2.458a1.0007 1.0007 0 0 0 .9727.772 1.0264 1.0264 0 0 0 .2294-.0264 1 1 0 0 0 .7452-1.2021l-.5772-2.458a2.9872 2.9872 0 0 0 -2.9209-2.3135h-1.3706l.4116-2.8574a1.0011 1.0011 0 0 0 -.9902-1.1426h-12.5918a1 1 0 0 0 -.8408 1.541l2.3467 3.6431-2.05 8.6645a4.971 4.971 0 0 0 .8733 4.1514h-5.0333v-30h5v.9971a3.0033 3.0033 0 0 0 3 3h1v.997a2.995 2.995 0 0 0 2 2.8159v1.1843a1 1 0 1 0 2 0v-1.1843a2.9951 2.9951 0 0 0 2-2.8158v-.997h1a3.0033 3.0033 0 0 0 3-3v-.9972h6a1 1 0 0 0 1-1v-8a5.0059 5.0059 0 0 0 -5-5h-36a5.0059 5.0059 0 0 0 -5 5v46a3.0033 3.0033 0 0 0 3 3h48a3.0033 3.0033 0 0 0 3-3v-2a1 1 0 0 0 -1-1zm-16.8584-20-.2881 2h-8.0283l-1.2881-2zm-9.4678 14.8613a2.9829 2.9829 0 0 1 -.5664-2.5517l1.9649-8.3096h7.8554l1.9649 8.31a3 3 0 0 1 -2.919 3.69h-5.9472a2.9825 2.9825 0 0 1 -2.3526-1.1387zm20.3262 3.1387a1.0006 1.0006 0 0 1 1 1v1h-28v-2zm-14-27.0059a1 1 0 1 1 -2 0v-.997h2zm4-3.997a1.0007 1.0007 0 0 1 -1 1h-1.9855l-.0145-.003-.0145.003h-3.971l-.0145-.003-.0145.003h-1.9855a1.0007 1.0007 0 0 1 -1-1v-.9971h10zm-32-12.9971h36a3.0033 3.0033 0 0 1 3 3v7h-25a1 1 0 0 0 -1 1v35h-16v-43a3.0033 3.0033 0 0 1 3-3zm47 49a1.0006 1.0006 0 0 1 -1 1h-48a1.0006 1.0006 0 0 1 -1-1v-1h50z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 51h10a1 1 0 0 0 0-2h-10a1 1 0 0 0 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 29.0029a3 3 0 1 0 -3-3 3.0033 3.0033 0 0 0 3 3zm0-4a1 1 0 1 1 -1 1 1.0007 1.0007 0 0 1 1-1z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 36.999a3 3 0 1 0 -3-3 3.0033 3.0033 0 0 0 3 3zm0-4a1 1 0 1 1 -1 1 1.0007 1.0007 0 0 1 1-1z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 44.9971a3 3 0 1 0 -3-3 3.0033 3.0033 0 0 0 3 3zm0-4a1 1 0 1 1 -1 1 1.0006 1.0006 0 0 1 1-1z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 11h22a1 1 0 0 0 0-2h-22a1 1 0 0 0 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsulasIcon);
export default __webpack_public_path__ + "static/media/capsulas-icon.2fa50c2a2fd093e62dd3e38b3a8931d5.svg";
export { ForwardRef as ReactComponent };